import Vue from 'vue';
import AsideModel from './AsideModal.vue';
import BottomModal from './BottomModal.vue';
import BoxLoader from './box-loader.vue';
import BroadcastNotice from './broadcast-notice.vue';
import Calendar from './Calendar.vue';
import CurrencySelector from './CurrencySelector.vue';
import CustomFilter from './filter/custom-filter.vue';
import Datepicker from './Datepicker.vue';
import Dropzone from './vue_dropzone.vue';
import EsTablePagination from './es-table-pagination.vue';
import LabelList from '../franchise_component/label/label-list.vue';
import LabelOutletList from '../franchise_component/label/label-outlet-list.vue';
import LoadingSpinner from './LoadingSpinner.vue';
import MetricSummary from './MetricSummary.vue';
import Modal from './modal.vue';
import Monthpicker from './Monthpicker.vue';
import OutletSelector from './OutletSelector.vue';
import TillFilter from './till-filter/till-filter.vue';
import TillSelector from './TillSelector.vue';
import Timepicker from './timepicker.vue';
import TimezoneSelector from './TimezoneSelector.vue';
import VueDropzonePopup from './VueDropzonePopup.vue';
import VueGoogleAutocomplete from './VueGoogleAutocomplete.vue';

/**
 * Async components are not used here since there's some slight delay when
 * loading them in other async components
 */
Vue.component('aside-modal', AsideModel);
Vue.component('bottom-modal', BottomModal);
Vue.component('box-loader', BoxLoader);
Vue.component('broadcast-notice', BroadcastNotice);
Vue.component('calendar', Calendar);
Vue.component('currency-selector', CurrencySelector);
Vue.component('custom-filter', CustomFilter);
Vue.component('datepicker', Datepicker);
Vue.component('dropzone', Dropzone);
Vue.component('es-table-pagination', EsTablePagination);
Vue.component('label-list', LabelList);
Vue.component('label-outlet-list', LabelOutletList);
Vue.component('loading-spinner', LoadingSpinner);
Vue.component('metric-summary', MetricSummary);
Vue.component('modal', Modal);
Vue.component('monthpicker', Monthpicker);
Vue.component('outlet-selector', OutletSelector);
Vue.component('till-filter', TillFilter);
Vue.component('till-selector', TillSelector);
Vue.component('time-picker', Timepicker);
Vue.component('timezone-selector', TimezoneSelector);
Vue.component('vue-dropzone-popup', VueDropzonePopup);
Vue.component('vue-google-autocomplete', VueGoogleAutocomplete);

import './datatable-header';
import './datatable-loader';
import './export-detail';
import './selector';
